export enum TodoFilter {
  All = 'All',
  Active = 'Active',
  Completed = 'Completed',
}
